import { TableCell, TableRow } from '@fluentui/react-components';
import { TSparseSubmission } from '../../types/submissions.types';
import { AvatarGroup } from '@modules/users';
import { DateLabel, SmartTableCell } from '@shared/components';
import { TJurisdictionMap } from '@modules/items';
import { useParams } from 'react-router-dom';
import getOverviewProgress from '@modules/submissions/helpers/getOverviewProgress.helpers';
import SubmissionStatusBadge from '../SubmissionStatusBadge';

type TProps = {
  submission: TSparseSubmission;
  jurisdictionsMap: TJurisdictionMap;
};

const SubmissionTableItem = ({ submission, jurisdictionsMap }: TProps) => {
  const { productId } = useParams();

  const progress = getOverviewProgress(submission);
  const isOverdue = submission.dueDate && new Date(submission.dueDate) < new Date();

  return (
    <TableRow>
      {/* 1) Submission title column */}
      <SmartTableCell
        cellProps={{ className: '!pl-4' }}
        variant={{ kind: 'link', href: `/product/${productId}/submissions/${submission._id}`, label: submission.title }}
        padding="large"
        openMode="sameTab"
      />

      {/* 2) Jurisdiction column (e.g. "MDR", "FDA", etc.) */}
      <SmartTableCell
        variant={
          submission.jurisdiction && jurisdictionsMap[submission.jurisdiction]
            ? {
                kind: 'link',
                href: `/folder/${submission.jurisdiction}`,
                label: jurisdictionsMap[submission.jurisdiction],
              }
            : {
                kind: 'text',
                label: 'Archived',
              }
        }
        linkDanger={Boolean(submission.jurisdiction && !jurisdictionsMap[submission.jurisdiction])}
        tooltip={{ threshold: 40 }}
      />

      {/* 3) Status column */}
      <TableCell>
        <SubmissionStatusBadge status={submission.status} />
      </TableCell>

      {/* 4) Progress column (e.g. "79%") */}
      <TableCell>{progress}%</TableCell>

      {/* 5) Due date column (highlight if danger) */}
      <TableCell className={isOverdue ? 'text-red-500' : undefined}>
        {submission.dueDate ? <DateLabel short>{submission.dueDate}</DateLabel> : '-'}
      </TableCell>

      {/* 6) Leads column (render user avatars by ID) */}
      <TableCell>
        <AvatarGroup ids={submission.leads} />
      </TableCell>
    </TableRow>
  );
};

export default SubmissionTableItem;
